module.exports = __webpack_public_path__ + "img/4.2682363d.png";